import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrionSettingsDialogComponent } from './orion-settings-dialog.component';
import { DevExtremeModule } from '../devextreme.module';

// CR-20260904-001, ORION Settings follow-on (2026-09-08). OrionSettingsService is providedIn root.
@NgModule({
   declarations: [
      OrionSettingsDialogComponent
   ],
   imports: [
      CommonModule,
      DevExtremeModule
   ],
   exports: [
      OrionSettingsDialogComponent
   ]
})
export class OrionSettingsDialogModule {}
